export interface IDonorSearchRequest {
    centerId: number,
    firstName: string,
    lastName: string,
    alias: string,
    email: string,
    dateOfBirth: string,
    includeNkr: boolean,
    includeDash: boolean,
    includeMiSite: boolean, //CHANGE
    dateSearchType: number,
    filterStartDate: string,
    filterEndDate: string,
    disposition: number,
    showFilter: number,
    centerStatus: number,
    isInEmr: number,
    coordinatorId: number,
    organType: number | null,
    followUpDays: number | null,
    isLostInPwl: boolean | null,
    stopCommunication: number | null,
    connectToDonorIsDesired: number | null,
    referralStatus: number | null,
    livingDonorPrioritization: boolean,
    referred: boolean,
    donated: boolean,
    includeAllMs: boolean,
    excludeTransferredAndDuplicate?: boolean,
    micrositeRecipientId: number,
    maxResults?: number | null
}
